// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9323) return "static/chunks/25b8c134.16eb2ff71ee999f2.js";
	if (chunkId === 6079) return "static/chunks/363642f4.0716f73985ea7e0d.js";
	if (chunkId === 8897) return "static/chunks/71d5b6fe.beb5050da26e5020.js";
	if (chunkId === 3673) return "static/chunks/3673.cf56019305dbbefe.js";
	if (chunkId === 1028) return "static/chunks/1028.16fec7e14279d803.js";
	if (chunkId === 605) return "static/chunks/605.8e07aad42f2e4753.js";
	if (chunkId === 2682) return "static/chunks/2682.8692e3fef463b891.js";
	if (chunkId === 1088) return "static/chunks/1088.96620cdbbfe88aee.js";
	if (chunkId === 7386) return "static/chunks/7386.edbeb2be0f69daaa.js";
	if (chunkId === 2043) return "static/chunks/2043.30f999b341be204f.js";
	if (chunkId === 7042) return "static/chunks/7042.d86fc0c42758434b.js";
	if (chunkId === 1481) return "static/chunks/1481.9872fadf6ca134d5.js";
	if (chunkId === 8042) return "static/chunks/8042.611efcbfbb08453f.js";
	if (chunkId === 3777) return "static/chunks/3777.1a0008ced43739db.js";
	if (chunkId === 1336) return "static/chunks/1336.0d0089c5bb7aacb6.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2266":"870fdd6f","2545":"c16f53c3","5802":"69b09407","7330":"d3ac728e","8229":"9da6db1e"}[chunkId] || chunkId) + "-GJjCW2U6wlIoUF339ouPm.js";
};